import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { GetSupportTicketsResponse } from "@src/types/support";
import { mockSupportTickets } from "./mocks/get-support-tickets-mock";

const USE_MOCK = false;

export const getSupportTickets = async (
  namespace: string,
): Promise<{ data: GetSupportTicketsResponse }> => {
  if (USE_MOCK) {
    return { data: mockSupportTickets };
  }

  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetSupportTicketsResponse>(
      `${url}/api/v1/ns/${namespace}/tickets`,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch tickets. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while fetching tickets.");
  }
};
